import { ReactElement, useContext, useState } from "react"
import { AuthContext, Rotina } from "../../../context/Auth";
import { Agrup, ButtonRotina, Icon, Organize, Seta, SubAgrup } from "../style";
import home from "../../../assets/img/Home.svg";
import seta from "../../../assets/img/seta.svg";
import { ButtonMenu } from "../ButtonMenu";
import { useLocation } from "react-router-dom";

export const MenuAcolher = (): ReactElement | null => {

  const { usuarioRotinas } = useContext<any>(AuthContext);

  const [acolher, setAcolher] = useState<boolean>(false);

  const { pathname } = useLocation();
  const menus = usuarioRotinas.map((rotina: Rotina) => rotina.nomemenu);
  const rotinas = usuarioRotinas.map((rotina: Rotina) => rotina.nomerotina);

  return (
    <>
        {
              menus.some(
                (menu: string) => menu == "Acolher"
              ) ?
                <ButtonRotina onClick={() => (setAcolher(!acolher))}>
                  <Organize
                  active={pathname?.match('acolher')}
                  aria-label="Menu Acolher">
                    <Agrup>
                      <Icon src={home} />
                      <p>Acolher</p>
                    </Agrup>
                    <Seta src={seta} active={acolher} />
                  </Organize>
                  {
                    acolher ?
                      <SubAgrup onClick={(event) => event?.stopPropagation()}>
                        {
                          rotinas.some((rotina: string) => rotina == "Visitante") ?
                            <>
                              <ButtonMenu direcao="/dash/acolher/visitantes" nomeEstilo="subitem" titulo="Visitantes" />
                            </>
                            : false
                        }
                        {
                          rotinas.some((rotina: string) => rotina == "Mensagens") ?
                            <>
                              <ButtonMenu direcao="/dash/acolher/mensagens" nomeEstilo="subitem" titulo="Mensagens" />
                            </>
                            : false
                        }
                      </SubAgrup>
                      : false
                  }
                </ButtonRotina>
                : false
            }
    </>
  )
}
